import { camelCase, isElement, isObject, replace, startsWith } from "lodash";

export function parseDataAttr(elem, name, def) {
  let value = elem ? elem.getAttribute(name) : null;
  return value ? parseIfJson(value) : def !== undefined ? def : false;
}

export function parseIfJson(value) {
  try {
    return JSON.parse(value);
  } catch (error) {
    return value;
  }
}

export function htmlToElement(html) {
  let span = document.createElement("span");
  span.innerHTML = html.trim();
  return span.firstChild;
}

export function renderAsHtml(template, data) {
  return typeof template === "function" ? template(data) : template;
}

export function renderAsElement(template, data) {
  let html = renderAsHtml(template, data);
  return htmlToElement(html);
}

export function toggleClasses(elem, classes) {
  classes = (classes || "").split(" ");
  if (isElement(elem)) {
    classes.forEach(function (classString, index) {
      elem.classList.toggle(classString);
    });
  }
}

export function getOptionsFromElement(elem) {
  if (!isElement(elem)) {
    return {};
  }
  // Check for json encoded data-options attribute
  let options = parseDataAttr(elem, "data-options", {});
  if (!isObject(options)) {
    options = {};
  }
  // Check for any individual data-option attributes
  let attributes = Array.from(elem.attributes);
  if (attributes.length) {
    attributes.forEach(function (attribute) {
      if (startsWith(attribute.nodeName, "data-option-")) {
        let optionName = camelCase(replace(attribute.nodeName, "data-option-", ""));
        options[optionName] = parseIfJson(attribute.nodeValue);
      }
    });
  }
  return options;
}

export function isOutOfViewport(elem) {
  let bounding = elem.getBoundingClientRect();
  let out = {};
  out.top = bounding.top < 0;
  out.left = bounding.left < 0;
  out.bottom = bounding.bottom > (window.innerHeight || document.documentElement.clientHeight);
  out.right = bounding.right > (window.innerWidth || document.documentElement.clientWidth);
  out.any = out.top || out.left || out.bottom || out.right;
  out.all = out.top && out.left && out.bottom && out.right;
  return out;
}

export function getPosition(element) {
  let rect = element.getBoundingClientRect();
  let scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
  let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  return {
    top: rect.top + scrollTop,
    left: rect.left + scrollLeft,
  };
}

export function clonedNodeToElement(clonedNode) {
  let span = document.createElement("span");
  span.appendChild(clonedNode);
  return span.firstChild;
}
